<template>
    <!-- Alert Success Action Sheet -->
    <div class="modal fade action-sheet" id="actionSheetAlertSuccess" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="iconbox text-success" v-if="type == 'Success'">
                            <ion-icon name="checkmark-circle"></ion-icon>
                        </div>
                        <div class="iconbox text-danger" v-if="type == 'Error'">
                            <ion-icon name="alert-circle"></ion-icon>
                        </div>
                        <div class="iconbox text-warning" v-if="type == 'Warning'">
                            <ion-icon name="alert-circle"></ion-icon>
                        </div>
                        <div v-if="type == 'Error'" class="text-center alert-error-body">
                            <h3 class="alert-error-title">{{ type }}</h3>
                            <p class="mal-text alert-error-message" v-html="message"></p>
                            <p class="mal-text alert-error-hint">സഹായത്തിന് വാട്സ്ആപ്പ് വഴി ബന്ധപ്പെടാൻ</p>
                        </div>
                        <div v-else class="text-center p-2">
                            <h3>{{ type }}</h3>
                            <p class="mal-text text-primary" v-html="message"></p>
                        </div>
                        <a href="javascript:void(0)" v-if="type == 'Error'" class="btn btn-success btn-lg btn-block alert-error-whatsapp-btn" @click="openWhatsApp()">
                            <ion-icon name="logo-whatsapp" class="alert-error-whatsapp-icon"></ion-icon>
                            <span class="alert-error-whatsapp-label">ഇവിടെ ക്ലിക്ക് ചെയ്യുക</span>
                        </a>
                        <!-- Show Close button for Success and Warning messages -->
                        <a href="javascript:void(0)" v-if="type == 'Success' || type == 'Warning'" class="btn btn-primary btn-lg btn-block" @click="closeModel()">
                            Close
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Alert Success Action Sheet -->
</template>
<script>
import $ from 'jquery';
export default {
    props: {
        type: String,
        message: String,
        redirectRoute: String,
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        openModel() {
            $('#actionSheetAlertSuccess').modal('show');
        },
        closeModel() {
            $('#actionSheetAlertSuccess').modal('hide');
            if (this.redirectRoute) {
                this.$router.push(this.redirectRoute);
            }
        },
        openWhatsApp() {
            $('#actionSheetAlertSuccess').modal('hide');
            window.location.href = 'https://wa.me/919526221177?text=For%20PIN%20Number.';
        },
    },
    mounted() {
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
};
</script>

<style scoped>
.alert-error-body {
    padding: 0.5rem 0.75rem 0.25rem;
}

.alert-error-title {
    margin: 0 0 0.4rem;
    font-weight: 700;
    font-size: 1.25rem;
}

.alert-error-message,
.alert-error-hint {
    margin: 0;
    padding: 0;
    line-height: 1.3;
    font-weight: 700;
    font-size: 1.05rem;
    color: #163268;
}

.alert-error-hint {
    margin-top: 0.25rem;
    color: #2c3e50;
}

.alert-error-whatsapp-btn {
    margin-top: 0.5rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    line-height: 1.2;
    padding: 0.85rem 1rem;
    text-decoration: none;
}

.alert-error-whatsapp-icon {
    font-size: 1.6rem;
    flex-shrink: 0;
}

.alert-error-whatsapp-label {
    white-space: nowrap;
    font-size: 1.1rem;
    font-weight: 700;
}
</style>